import {RouteStop} from "../../../api/Logistics";
import {api} from "../../../api/API";
import {EditAddressTemplate} from "../../settings/companies/clients/client/EditAddressTemplate";

export function AddressManageSupplier(props: {
    value: RouteStop;
    onClose(): void;
    onUpdate(value: RouteStop): Promise<any>;
}) {

    return (
        <EditAddressTemplate
            title="Company Address"
            street={props.value.addressStreet || ""}
            city={props.value.addressCity || ""}
            province={props.value.addressProvince || ""}
            postal={props.value.addressPostal || ""}
            onClose={props.onClose}
            onUpdate={async (input) => {
                const id = props.value.manufacturer;
                if(!id) throw new Error("invalid manufacturer id");
                const co = await api.companies.get({id: id})

                await api.companies.upsert(Object.assign({}, co, {
                    addressStreet: input.street,
                    addressCity: input.city,
                    addressProvince: input.province,
                    addressPostal: input.postal,
                }))

                // trigger reload
                return props.onUpdate(Object.assign({}, props.value));
            }}
        />
    )
}